export default "__VITE_ASSET__nB5$u8C0__"